module.exports = __webpack_public_path__ + "static/media/custom-filter-icon.3e111c67.svg";